import React, { useState, useEffect } from "react";

import Table from "../common/Table";
import Option from "../common/RowOption";
import calc from "../../utils/calculation";

import lbl from "../../data/Labels.json";

const FinancePayableList = ({ activeYear, data, setChart }) => {
  const payablesColumns = [
    { path: "id", label: "شماره" },
    {
      path: "verification_date",
      label: "تاریخ",
    },
    {
      path: "attachment",
      label: "سند",
      content: ({ attachment }) =>
        attachment && (
          <a href={attachment} download target="_blank">
            {lbl.Download}
          </a>
        ),
    },
    { path: "verified_by_staff_name", label: "تایید کننده" },
    { path: "modified_by_staff_name", label: "ثبت کننده" },
    { path: "remark", label: "ملاحظه" },
    { path: "amount", label: "قابل پرداخت" },
    {
      path: "option",
      content: (e) => (
        <Option
          Delete={{ route: "creditors/debt", id: e.id }}
          Edit={{
            form: "creditor-debt-form",
            cache: e.creditor_id,
            edit: e,
          }}
        />
      ),
    },
  ];

  const [rows, getRows] = useState([]);

  useEffect(() => {
    if (data.data) {
      const filteredData = data?.data[0]?.payables.filter(
        (p) => p.half_year_id === (activeYear.half_year_id || activeYear)
      );
      getRows(filteredData);
    }
  }, [activeYear]);

  return (
    <div className="table-card">
      <p className="table-title">{lbl.Payables}</p>
      <Table
        data={rows}
        columns={payablesColumns}
        total={rows && calc.getTotal(rows, "amount")}
      />
    </div>
  );
};

export default FinancePayableList;
